import axios from 'axios'
import _ from 'lodash'

let call_stack = [];
const CancelToken = axios.CancelToken;
axios.interceptors.request.use(function (config) {
	// Do something before request is sent
	let call_data = {
		call_url: config.url,
		call_method: config.method,
		call_param: config.data || {}
	};
	if (_.findIndex(call_stack, call_data) == -1) {
		call_stack.push(call_data);
		return config;
	} else {
		//동일한 axios call 취소
		return {
			...config,
			//cancelToken: (new CancelToken((cancel) => cancel('중복된 요청 취소')))
			cancelToken: (new CancelToken(() => { }))
		};
	}
	//return config;
}, function (error) {
	// Do something with request error
	return Promise.reject(error);
});

axios.interceptors.response.use(function (config) {
	// Do something before request is sent
	let call_data = {
		call_url: config.config.url,
		call_method: config.config.method,
		call_param: config.config.data
	};
	call_stack.splice(_.findIndex(call_stack, call_data), 1);

	return config;
}, function (error) {
	// Do something with request error
	return Promise.reject(error);
});

export default {


	/*
	** API 서버 (직장맘 실서버 환경)
	*/
	// scheme: "https",
	// host: "www.seoulworkingmom.or.kr", // 코드명인 개발서버
	scheme: location.protocol,
	host: location.host,

	/*
	** 직장맘 분기 정보
	*/
	logo: {
		img: 'url("images/basic/logo.png")',
		title: '서북권직장맘지원센터',
	},
	
	boardTypeSelect : {
		articleListType: [
			{name:"항목형", value:"list"},
			{name:"내용 펼침형", value:"acordian"},
			{name:"이미지", value:"image"},
			{name:"이미지+설명형", value:"imageDetail"},
			{name:"답변형", value:"counselingReply"},
		],
		
		articleDetailType: [
			{name:"게시글(기본)", value:"articleDetail"},
			{name:"게시글+답글", value:"counselingReplyDetail"}
		],

		articleWriteType: [
			{name:"상담형", value:"counselingReplyWrite"}
		]
	},

	applFormType: {
    link: true,
    name: '신청양식 링크 설정',
	},
	
	applFormSelect: [
		{name:"공통", value:"공통"},
		{name:"런치노동법", value:"런치노동법"},
	],

	applSampleExcel: "appl_west_sample.xlsx",

	hostParentName: "sb",
	counselBoardId: 222, // 온라인상담게시판 BOARD_ID
	counselSurveyId: 38, // 온라인상담설문 SURVEY_ID
	counselReplySurveyId: 46, // 온라인상담설문 SURVEY_ID
	trashBoardId: 361, // 휴지통 BOARD_ID
	
	// addr: function () {
	// 	return (this.scheme ? this.scheme + ":" : "") + "//" + this.host + (this.port ? ":" + this.port : "");
	// },
	addr: function () {
		return this.scheme + "//" + this.host + (this.port ? ":" + this.port : "");
	},

	cms: function () {
		/*
		** CMS 서버 (국어원 실서버 환경)
		*/
		return "https://edu.korean.go.kr/api" // 국어원 실서버

		/*
		** CMS 서버 (코드명인 개발서버 환경)
		return "http://codegurus.iptime.org:7877" // 코드명인 개발서버
		*/
	},

	dev_mode: false,
	api: {
		AUTHORIZATION: "/login/check",
		COMMON_CODE: "/code",
		FILTERS_ALL: "/filter",
		FILTERS: "/sys/filter",
		FILE: "/file",
		CATEGORY: "/sys/cate",
		CATEGORY_ALL: "/sys/cateAll",
		AUTH: "/sys/auth",
		APPL: "/appl",
		APPL_EDU_DATE: "/applEduDate",
		APPLY_GUIDE: "/sys/applGuide",
		APPL_EDU: "/applEdu",
		SURVEY: '/survey',
		SURVEY_ITEM: '/surveyItem',
		SURVEY_APPL: '/surveyAppl',
		SURVEY_ITEM_APPL: "/surveyItemAppl",
		SURVEY_CATEGORY: '/surveyCategory',
		CURRICULUM_SURVEY_MAPPING: "/curriculumSurveyMapping",
		EXAM: "/exam",
		EXAM_ITEM: "/examItem",
		EXAM_CATEGORY: "/examCategory",
		CURRICULUM_EXAM_MAPPING: "/curriculumExamMapping",
		MBER: "/mber",
		MEMBER: "/member",
		MEMBER_DELETE: "/deleteMember",
		WORK_INFO: "/member/workInfo",
		LES: "/les",
		LECTURE: "/lec",
		LECTURE_TEMPLATE: "/sys/lecTempl",
		CURRICULUM: "/curriculum",
		EMAIL_TEMPLATE: "/sys/emailTempl",
		EMAIL_FAVORITE: "/sys/emailFavorite",
		EMAIL_RESULT: "/sys/emailResult",
		SMS_TEMPLATE: "/sys/smsTempl",
		SMS_FAVORITE: "/sys/smsFavorite",
		SMS_SEND: "/sys/smsSend",
		BOARD: "/board",
		SITE: "/site",
		SITE_ARTICLE: "/siteArticle",
		PRENEXT_SITE_ARTICLE: "/siteArticlePreNextInfo",
		LOG: "/sym/log/wlg/SelectWebLogList",
		MENU: "/sys/menu",
		ARTICLE: "/article",
		PRENEXT_ARTICLE: "/articlePreNextInfo",
		COMMENT: "/comment",
		POPUP: "/sys/popup",
		AGENCY: "/sys/agency",
		ASSIGN: "/assign",
		ASSIGN_APPL: "/assignAppl",
		ATTEN: "/atten",
		NOTIFICATION: "/notification",
		EVENT: "/event",
		ARTICLE_CATEGORY: "/articleCategory",

		ARTICLE_EXCEL: "/excel/article",
		APPL_EXCEL: "/excel/appl",
		MBER_EXCEL: "/excel/mber",
		AGENCY_EXCEL: "/excel/agency",
		LECTURE_EXCEL: "/excel/lec",
		SURVEY_APPL_EXCEL: "/excel/surveyAppl",
		SURVEY_EXCEL: "/excel/survey",
		SURVEY_STATISTICS_EXCEL: "/excel/surveyStatistics",
		EXAM_EXCEL: "/excel/exam",
		LOG_EXCEL: "/excel/log",
	},


	// 조회
	postAxios: function (db_name, config, cb) {
		let url = this.addr() + '/' + _.camelCase(db_name);

		if (db_name.indexOf('/') != -1) {
			url = this.addr() + '/' + db_name
		}

		if (this.dev_mode) {
			url = this.addr() + db_name;
		}
		let config_options = config || {};
		axios.post(url, config_options)
			.then(function ({ data }) {
				cb({ data, err: '' })
			})/*.catch((e) => {
				cb({ data: {}, err: e })
			})*/
	},
	// 생성
	putAxios: function (db_name, config, cb) {
		let url = this.addr() + '/' + _.camelCase(db_name);

		if (db_name.indexOf('/') != -1) {
			url = this.addr() + '/' + db_name
		}

		if (this.dev_mode) {
			url = this.addr() + db_name;
		}
		let config_options = config || {};
		if (!_.isArray(config_options)) {
			config_options = [config_options];
		}

		if (config_options.length == 0) {
			cb({ data: {}, err: '' })
		} else {
			axios.put(url, config_options)
				.then(function ({ data }) {
					cb({ data, err: '' })
				}).catch((e) => {
					cb({ data: {}, err: e })
				})
		}

	},
	// 수정
	patchAxios: function (db_name, id, config, cb) {
		let url = this.addr() + '/' + _.camelCase(db_name) + '/' + id;

		if (db_name.indexOf('/') != -1) {
			url = this.addr() + '/' + db_name + '/' + id;
		}
		if (this.dev_mode) {
			url = this.addr() + db_name + '/' + id;
		}
		let config_options = config || {};
		axios.patch(url, config_options)
			.then(function ({ data }) {
				cb({ data, err: '' })
			}).catch((e) => {
				cb({ data: {}, err: e })
			})
	},

	patchListAxios: function (db_name, config, cb) {
		let url = this.addr() + '/' + _.camelCase(db_name);
		if (db_name.indexOf('/') != -1) {
			url = this.addr() + '/' + db_name;
		}
		if (this.dev_mode) {
			url = this.addr() + db_name;
		}
		let config_options = config || {};
		if (!_.isArray(config_options)) {
			config_options = [config_options];
		}

		if (config_options.length == 0) {
			cb({ data: {}, err: {} })
		} else {
			axios.patch(url, config_options)
				.then(function ({ data }) {
					cb({ data, err: '' })
				}).catch((e) => {
					cb({ data: {}, err: e })
				})
		}
	},

	//삭제
	deleteAxios: function (db_name, config, cb) {
		// config -> id 값만 받는다.
		let url = this.addr() + '/' + _.camelCase(db_name) + '/' + config.id;
		if (db_name.indexOf('/') != -1) {
			url = this.addr() + '/' + db_name + '/' + config.id;
		}
		if (this.dev_mode) {
			url = this.addr() + db_name + '/' + config.id;
		}
		axios.delete(url)
			.then(function ({ data }) {
				cb({ data, err: '' })
			}).catch((e) => {
				cb({ data: {}, err: e })
			})

	},
	deleteListAxios: function (db_name, config, cb) {
		// config -> id 값만 받는다.
		let url = this.addr() + '/' + _.camelCase(db_name);

		if (db_name.indexOf('/') != -1) {
			url = this.addr() + '/' + db_name;
		}

		if (this.dev_mode) {
			url = this.addr() + db_name + '/' + config.id;
		}
		let config_options = config || {};
		if (!_.isArray(config_options)) {
			config_options = [config_options];
		}
		if (config_options.length == 0) {
			cb({ data: {}, err: {} })
		} else {
			axios.delete(url, { data: config_options })
				.then(function (resp) {
					cb({ data: resp.data, err: '' })
				}).catch((e) => {
					cb({ data: {}, err: e })
				})
		}

	}


};